import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import frLocale from '@fullcalendar/core/locales/fr'; 
let calendar;
document.addEventListener('DOMContentLoaded', function () {
    let calendarEl = document.getElementById('reservation-calendar');
    if (!calendarEl) return;
    let postID = document.getElementById('reservation-calendar').dataset.postId; 
    let currentUser = document.getElementById('reservation-calendar').dataset.user; 

    function getInitialView() {
        return window.matchMedia("(max-width: 768px)").matches ? 'dayGridMonth' : 'timeGridWeek';
    }

    calendar = new Calendar(calendarEl, {
        plugins: [timeGridPlugin, dayGridPlugin, interactionPlugin],
        initialView: getInitialView(),
        locale: 'fr',
        selectable: true,
        timeZone: 'local',
        allDaySlot: false,
        events: `/wp-json/agenda/v1/bookings?room_id=${postID}&user=${currentUser}`, 
        firstDay: 1,
        buttonText: {
            today: "Aujourd'hui",
        },
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'reservationButton' 
        },
        customButtons: {
            reservationButton: {
                text: 'Demande de réservation',
                click: function () {
                    openBookingModal(null, null);
                }
            }
        },
    
        select: function(info) {
            if (isOverlapping(info.start, info.end)) {
                alert("Ce créneau chevauche un autre créneau déjà réservé.");
                calendar.unselect();
                return;
            }
            openBookingModal(info.start, info.end);
        },

        eventOverlap: false
    });

    calendar.render();
    window.addEventListener('resize', function () {
        let newView = getInitialView();
        if (calendar.view.type !== newView) {
            calendar.changeView(newView);
        }
    });
});

function isOverlapping(start, end) {
    let events = calendar.getEvents(); 
    for (let event of events) {
        let eventStart = event.start;
        let eventEnd = event.end;

        if (start < eventEnd && end > eventStart) {
            return true;
        }
    }
    return false;
}

function openBookingModal(start, end) {
    const modal = document.getElementById('booking_modal');
    const dateField = document.getElementById('date');
    const dateEndField = document.getElementById('date_end');
    const startTimeField = document.getElementById('start_time');
    const endTimeField = document.getElementById('end_time');

    if (start && end) {
        let startDate = new Date(start);
        let endDate = new Date(end);

        let date = startDate.getFullYear() + '-' +
        String(startDate.getMonth() + 1).padStart(2, '0') + '-' +
        String(startDate.getDate()).padStart(2, '0');

        let dateEnd = endDate.getFullYear() + '-' +
        String(endDate.getMonth() + 1).padStart(2, '0') + '-' +
        String(endDate.getDate()).padStart(2, '0');

        let startTime = startDate.toLocaleTimeString('fr-FR', { hour12: false }).substring(0, 5);  
        let endTime = endDate.toLocaleTimeString('fr-FR', { hour12: false }).substring(0, 5);  

        dateField.value = date;
        dateEndField.value = dateEnd;
        startTimeField.value = startTime;
        endTimeField.value = endTime;
    } else {
        dateField.value = "";
        dateEndField.value = "";
        startTimeField.value = "";
        endTimeField.value = "";
    }

    modal.style.display = "block";
}

function displayFormError(message){
    const form = document.getElementById('bookingForm');
    if( form ){
        // Delete previous error messages
        const previousErrors = form.querySelectorAll('.form-message.form-error');
        if( previousErrors ){
            previousErrors.forEach(e => e.remove());
        }

        // Create and display error node
        const errorNode = document.createElement('div');
        errorNode.className = 'form-message form-error';
        errorNode.innerText = message;
        form.prepend(errorNode);
    } else {
        // Form not found, display error on alert box
        alert(message);
    }

    // Scroll to top of modal to view error message
    const modal = document.getElementById('booking_modal');
    if( modal ){
        modal.scroll({top:0, behavior: 'smooth'})
    }
}


document.querySelector('.close').addEventListener('click', function() {
    document.getElementById('booking_modal').style.display = "none";
});

document.getElementById('bookingForm').addEventListener('submit', function(event) {
    event.preventDefault();

    let formData = new FormData(this);
    
    fetch('/wp-json/agenda/v1/send-reservation', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(result => {
        if (result && result.success) {
            window.history.pushState({}, '', window.location.pathname + '?reservation=success');
            location.reload();
        } else {
            displayFormError(result.data);
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    const url = new URL(window.location);
    const confirmationMessage = document.querySelector('.confirmation-message');

    if (url.searchParams.has('reservation')) {
        confirmationMessage.style.display = 'block'; 
    } else {
        confirmationMessage.style.display = 'none';
    }

    setTimeout(function () {
        if (url.searchParams.has('reservation')) {
            url.searchParams.delete('reservation');
            window.history.replaceState({}, '', url.pathname);
            confirmationMessage.style.display = 'none';
        }
    }, 5000); 
});

(function() {
    document.querySelectorAll('form input[name=token]').forEach(function(input) {
        var metaContent = document.querySelector('meta[name=refresh]');
        if (metaContent) {
            input.value = metaContent.getAttribute('content');
        }
    });
    document.querySelector('.booking-button').addEventListener('click', function() {
        openBookingModal(null, null); 
    });    
})();
